<!-- Sección para mostrar los temas -->
<ng-container *ngIf="(user?.userLinks?.plataformas || []).length > 0">
	<ng-container *ngFor="let item of user.userLinks.plataformas;index as i">
		<ng-container *ngIf="i%3 === 0;">
			<li style="overflow-x: hidden;overflow-y: hidden;">
				<a tabindex="-1" target="_blank" [href]="user.userLinks.plataformas[i].ptf_link"
					*ngIf="user.userLinks.plataformas[i]" class="a-redirect btn btn-transparent">
					<img height="40" width="40" [src]="'assets/img/pages-'+(user.userLinks.plataformas[i].ptf_id)+'.png'"
						alt="Acceso a Plataformas">
				</a>
				<a tabindex="-1" target="_blank" [href]="user.userLinks.plataformas[i + 1].ptf_link"
					*ngIf="user.userLinks.plataformas[i + 1]" class="a-redirect btn btn-transparent">
					<img height="40" width="40" [src]="'assets/img/pages-'+(user.userLinks.plataformas[i + 1].ptf_id)+'.png'"
						alt="Acceso a Plataformas">
				</a>
				<a tabindex="-1" target="_blank" [href]="user.userLinks.plataformas[i + 2].ptf_link"
					*ngIf="user.userLinks.plataformas[i + 2]" class="a-redirect btn btn-transparent">
					<img height="40" width="40" [src]="'assets/img/pages-'+(user.userLinks.plataformas[i + 2].ptf_id)+'.png'"
						alt="Acceso a Plataformas">
				</a>
			</li>
		</ng-container>
	</ng-container>
	<li class="divider" background="theme" apply="theme" style="width: 100%;"></li>
</ng-container>
<ng-container *ngFor="let item of themes || [];let i = index;">
	<ng-container *ngIf="i%3 === 0;">
		<li class="tooltipped tooltipped-logout" style="overflow-x: hidden;overflow-y: hidden;" data-position="left"
			data-tooltip="Cambiar el tema de fondo">
			<a tabindex="-1" *ngIf="themes[i]" (click)="themify(themes[i])" class="btn btn-transparent"><i
					[class]="'material-icons format-theme not-shadowing-text margin-all-0 color-i-'+themes[i]">web</i></a>
			<a tabindex="-1" *ngIf="themes[i + 1]" (click)="themify(themes[i + 1])" class="btn btn-transparent"><i
					[class]="'material-icons format-theme not-shadowing-text margin-all-0 color-i-'+themes[i + 1]">web</i></a>
			<a tabindex="-1" *ngIf="themes[i + 2]" (click)="themify(themes[i + 2])" class="btn btn-transparent"><i
					[class]="'material-icons format-theme not-shadowing-text margin-all-0 color-i-'+themes[i + 2]">web</i></a>
		</li>
	</ng-container>
</ng-container>
<li class="divider" background="theme" apply="theme" style="width: 100%;"></li>
<!-- Sección para cambiar el estilo de las tablas (Solo las referencias de componente) -->
<li class="tooltipped tooltipped-logout center-all" data-position="left"
	data-tooltip="Cambiar el estilo de las cabeceras" style="overflow-x: hidden;overflow-y: hidden;">
	<a tabindex="-1" (click)="themifyTemplate('theme')" class="btn btn-transparent" apply="theme" color="theme"><i
			class="material-icons format-theme not-shadowing-text margin-all-0">table_view</i></a>
	<a tabindex="-1" (click)="themifyTemplate('no-theme')" class="btn btn-transparent important" color="info"><i
			class="material-icons format-theme not-shadowing-text margin-all-0 important" color="info">table_view</i></a>
</li>
<li class="divider" background="theme" apply="theme" style="width: 100%;"></li>
<!-- Sección para desconectarse -->
<li mouse-action="color-danger-hover" class="important" apply="theme" color="background">
	<a tabindex="-1" (click)="updateCredentials()" class="not-shadowing-text" style="color: inherit;">Reiniciar
		<i class="material-icons not-shadowing-text" style="color: inherit;">refresh</i>
	</a>
</li>
<li class="divider" background="theme" apply="theme" style="width: 100%;"></li>
<!-- Sección para desconectarse -->
<li mouse-action="color-danger-hover" class="important" apply="theme" color="background">
	<a tabindex="-1" (click)="logOut()" [routerLink]="['/Home']" class="not-shadowing-text" style="color: inherit;">Salir
		<i class="material-icons not-shadowing-text" style="color: inherit;">exit_to_app</i>
	</a>
</li>